import React from 'react'

import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import { useTranslation } from 'language/translator'

import { TCoreWidget } from 'types/GlobalWidget'

interface BrokenProps {
  fetchWidgetData?: (widget: TCoreWidget) => void
  scaleFactor: number
  widget: TCoreWidget
}

const Broken = (props: BrokenProps) => {
  const { fetchWidgetData, scaleFactor, widget } = props
  const { t } = useTranslation()

  return (
    <EmptyPlaceholder
      background={true}
      body={t('global', 'error_500_helper_text')}
      title={`${t('global', 'error_500_title')} ${t(
        'widgets',
        'widget',
        true
      )}`}
      icon="HeartBrokenTwoTone"
      scaleFactor={scaleFactor}
      actions={
        fetchWidgetData ? (
          <Button onClick={() => fetchWidgetData(widget)} variant="outlined">
            {t('global', 'try_again')}
          </Button>
        ) : undefined
      }
    />
  )
}

export default Broken
